//TO CONFIG ON DEV ENVIRONMENT
import env from './env';
import dictionary from '../config/dictionary';
const data = {
    security: {
        permission: { url: env.api.permissionsAllow },
        login: { url: env.api.login },
    },
    configuration: {
        society: { url: env.api.society },
        country: { url: env.api.country },
        type: { url: env.api.type },
        message: { url: env.api.message },
        roleConcept: { url: env.api.rolceConcept },
        connectionSftp: { url: env.api.connectionSftp },
        template: { url: env.api.template },
        templateAssign: { url: env.api.templateAssign },
    },
    sap: {
        serviceSap: { url: env.api.serviceSap },
    },
    income: {
        documentType: { url: env.api.documentType },
        limitAmountEntity: { url: env.api.limitAmountEntity },
        account: { url: env.api.account },
        monitor: { url: env.api.monitor },
        client: { url: env.api.client },
        entity: { url: env.api.entity },
        summary: { url: env.api.summary },
        conciliationMonitor: { url: env.api.conciliationMonitor },
        branch: { url: env.api.branch },
        history: { url: env.api.paymentHistory},
        channel: { url: env.api.channel },
        channelTransaction: { url: env.api.channelTransaction },
        channelEntityPayment: { url: env.api.channelEntityPayment }
    },
    

    types: dictionary.configApp.concept,
    typeCode: dictionary.configApp.type
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    data
};